import axios from "axios";
import i18n from "../../../i18n";
import { handleHttpErrors } from "../../../modules/http";
import { decrypt } from "../../../modules/login";

const SET_USER_INFO = "SET_USER_INFO";
const SET_TIMEZONES_LIST = "SET_TIMEZONES_LIST";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

const getName = (state) => state.username;
const getEmail = (state) => state.email;
const getPhoneCountry = (state) => state.phoneCountry;
const getPhone = (state) => state.phone;
const getYearBirth = (state) => state.yearBirth;
const getNotifications = (state) => state.notifications;
const getParticipantLanguage = (state) => state.participantLanguage;
const getCaregiverId = (state) => decrypt(state?.loginReducer?.username);
const getCaregiverParticipantId = (state) => state.caregiverParticipantId;
const getTimezone = (state) => state.timezone;
const getTimeFormat = (state) => state.timeFormat;
const getTimezonesList = (state) => state.timezonesList;

const initialState = {
  username: "",
  caregiverParticipantId: "",
  email: "",
  phoneCountry: "",
  phone: "",
  yearBirth: "",
  notifications: null,
  timezone: "",
  timeFormat: "",
  timezonesList: null,
};

export function contactInformationFormReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        username: action.username,
        caregiverParticipantId: action.caregiverParticipantId,
        email: action.email,
        phoneCountry: action.phoneCountry,
        phone: action.phone,
        yearBirth: action.yearBirth,
        notifications: action.notifications,
        timezone: action.timezone,
        timeFormat: action.timeFormat,
      };
    case SET_TIMEZONES_LIST:
      return {
        ...state,
        timezonesList: action.timezonesList,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

const sendContactInformation = (formData) => (dispatch, getState) => {
  return axios
    .post(`/api/participant/contactinformation`, formData)
    .then(() => {
      return Promise.resolve(
        i18n.t("appText.participantContactInformation.post.success")
      );
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default: i18n.t("errorText.participantContactInformation.post"),
      });
    });
};

const fetchParticipant = (id) => (dispatch, getState) => {
  const { studies } = getState().loginReducer;

  const params = {
    participantId: id,
    studyId: studies ? studies[0]?.studyId : null,
  };

  return axios
    .get(`/api/participant/contactinformation`, {
      params,
    })
    .then(({ data }) => {
      dispatch({
        type: SET_USER_INFO,
        username: getCaregiverId(getState()),
        caregiverParticipantId: data.ugnxId,
        yearBirth: data.yearOfBirth,
        email: data.email,
        phoneCountry: data.country,
        phone: data.phoneNumber,
        notifications: data.notifications,
        timezone: data.timezone,
        timeFormat: data.timeFormat,
      });
    })
    .catch((e) => {
      dispatch({
        type: SET_USER_INFO,
        username: null,
        caregiverParticipantId: null,
        yearBirth: null,
        email: null,
        phoneCountry: null,
        phone: null,
        notifications: null,
        timezone: null,
        timeFormat: null,
      });
    });
};

const fetchTimezonesList =
  (locale = "en") =>
  (dispatch, getState) => {
    const params = {
      locale,
    };

    return axios
      .get(`/api/participant/timezones`, { params })
      .then(({ data }) => {
        dispatch({
          type: SET_TIMEZONES_LIST,
          timezonesList: data,
        });
      })
      .catch(() => {
        dispatch({
          type: SET_TIMEZONES_LIST,
          timezonesList: null,
        });
      });
  };

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    username: getName(state),
    email: getEmail(state),
    phoneCountry: getPhoneCountry(state) || "us",
    phone: getPhone(state),
    yearBirth: getYearBirth(state),
    notifications: getNotifications(state),
    participantLanguage: getParticipantLanguage(state),
    caregiverParticipantId: getCaregiverParticipantId(state),
    timezone: getTimezone(state),
    timeFormat: getTimeFormat(state),
    timezonesList: getTimezonesList(state),
  };
};

export const mapDispatchToProps = {
  sendContactInformation,
  fetchParticipant,
  resetState,
  fetchTimezonesList,
};
